const Search = ({ onSearch, value, onChange }) => {
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            onSearch(value);
        }
    };

    return (
        <div className="search-input-header">
            <input
                type="text"
                placeholder="Search"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            <i className="fa-regular fa-magnifying-glass"></i>
        </div>
    );
};

export default Search;